var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.mapLoaded)?_c('loader'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ui container"},[(_vm.networkUnknown)?_c('div',{staticClass:"ui segment center aligned raised",staticStyle:{"margin-top":"1em"}},[_vm._v("\n      Select "),_c('b',[_vm._v("Main Network")]),_vm._v(" in MetaMask\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"id":"map"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f3c1dd8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = null
// module chunks = 